import React from 'react'
import { ViewPropTypes, View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'
import ContentLoader, { Rect } from 'react-content-loader/native'

import VfText from '../VfText'

import styles from './SelectGroup.Styles'

const LoadingContent = (props) => {
    return <View style={[styles.option, props.style]} >
        <ContentLoader
            speed={2}
            width={100}
            height={40}
            viewBox="0 0 100 40"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <Rect x="0" y="3" rx="6" ry="6" width="100" height="15" />
            <Rect x="10" y="26" rx="6" ry="6" width="80" height="12" />
        </ContentLoader>
    </View>
}

LoadingContent.propTypes = {
    style: PropTypes.object,
}

function SelectGroup(props) {

    const {
        options,
        style,
        containerStyle,
        optionStyle,
        activeOptionStyle,
        titleStyle,
        activeTitlestyle,
        descStyle,
        activeDescStyle,
        selected,
        setSelected,
        isLoading,
    } = props

    return (
        <View style={[{height: Math.ceil(options?.length / 3) * 73}, containerStyle]}>
        <View style={[styles.container, style]}>
            {isLoading
                ? <>
                    <LoadingContent style={styles.firstLoader} />
                    <LoadingContent style={styles.lastLoader} />
                </>

                : options.map((item, index) => {
                    const active = index === selected
                    const itemStyle = {}
                    if (index % 3 === 0){
                        itemStyle.marginLeft = 0
                    }
                    if (index % 3 === 2 || index === options.length - 1){
                        itemStyle.marginRight = 0
                    }
                    return (
                        <TouchableOpacity
                            disabled={item.disabled || !setSelected}
                            onPress={() => setSelected(index)}
                            style={[
                                styles.option,
                                optionStyle,
                                active && styles.activeoption,
                                active && activeOptionStyle,
                                itemStyle,
                            ]}
                            activeOpacity={0.5}
                        >
                            <VfText
                                size="h5"
                                i18nKey={item.title || ''}
                                style={[
                                    styles.title,
                                    titleStyle,
                                    active && styles.activeTitle,
                                    active && activeTitlestyle,
                                ]}
                            />
                            {item.desc ? <VfText
                                size="footnote"
                                i18nKey={item.desc || ''}
                                style={[
                                    styles.desc,
                                    descStyle,
                                    active && styles.activeDesc,
                                    active && activeDescStyle,
                                ]}
                            /> : null}
                        </TouchableOpacity>
                    )
                })}
        </View>
        </View>
    )
}

SelectGroup.defaultProps = {
    options: [{},{}],
    style: {},
    containerStyle: {},
    optionStyle: {},
    activeOptionStyle: {},
    titleStyle: {},
    activeTitlestyle: {},
    descStyle: {},
    activeDescStyle: {},
    selected: -1,
    setSelected: () => { },
    isLoading: false,
}

SelectGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            desc: PropTypes.string,
            disabled: PropTypes.bool,
        })
    ),
    style: ViewPropTypes.style,
    containerStyle: PropTypes.object,
    optionStyle: PropTypes.object,
    activeOptionStyle: PropTypes.object,
    titleStyle: PropTypes.object,
    activeTitlestyle: PropTypes.object,
    descStyle: PropTypes.object,
    activeDescStyle: PropTypes.object,
    selected: PropTypes.number,
    setSelected: PropTypes.func,
    isLoading: PropTypes.bool,
}

export default SelectGroup
